/* globals process require */
const contentful = require('contentful');
const client = contentful.createClient({
  space: process.env.VUE_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.VUE_APP_CONTENTFUL_API_KEY,
  removeUnresolved: true,
  host: process.env.VUE_APP_CONTENTFUL_HOST,
});

export default client;
